/**
 * Created by rickborst on 22/02/2017.
 */

import {hashHistory} from 'react-router';
import _ from 'lodash';

import {getInstance as getDataSources} from 'datasources';
import {fetchLinearChannels} from 'store/actions/linearchannels';

// Action types
const ActionTypes = {
        UPDATE_SESSION: 'UPDATE_SESSION',
        SET_LOGGED_IN_STATUS: 'SET_LOGGED_IN_STATUS',
        SET_REDIRECT_URL: 'SET_REDIRECT_URL',
        SET_SESSION_STATUS: 'SET_SESSION_STATUS',
        SET_ADBLOCK_STATUS: 'SET_ADBLOCK_STATUS'
    },

    // Status values
    LoggedInStatuses = {
        UNAUTHORIZED: false,
        AUTHORIZED: true
    },
    SessionStatuses = {
        CAN_NOT_REFRESH: true,
        CAN_REFRESH: false
    },
    AdBlockStatuses = {
        DETECTED: true,
        NOT_DETECTED: false
    };

/**
 * Set logged in status action.
 *
 * @param {boolean} status - New status of the component.
 * @returns {Object} Action type and the new status.
 */
function setLoggedInStatus (status) {

    return {
        type: ActionTypes.SET_LOGGED_IN_STATUS,
        status: status
    };
}

/**
 * Set session status.
 *
 * @param {boolean} status - New status of the component.
 * @returns {Object} Action type and the new status.
 */
function setSessionStatus (status) {

    return {
        type: ActionTypes.SET_SESSION_STATUS,
        sessionStatus: status
    };
}

/**
 * Set redirect URL action.
 *
 * @param {string} url - Redirection URL.
 * @returns {Object} Action type and the url.
 */
function setRedirectUrl (url) {

    return {
        type: ActionTypes.SET_REDIRECT_URL,
        url: url
    };
}

/**
 * Attempt anonymous login action.
 *
 * @returns {Promise} Response to the request.
 */
function attemptAnonymousLogin () {
    return () => {
        let dataSources = getDataSources();

        return dataSources.anonymousLogin();
    };
}

/**
 * Update Session action.
 *
 * @param {Object} session - Session object.
 * @returns {Object} Action type and session.
 */
function updateSession (session) {

    return {
        type: ActionTypes.UPDATE_SESSION,
        session: session
    };
}

/**
 * Update adblock status.
 *
 * @param {boolean} status - Adblock status.
 * @returns {Object} Action type and status.
 */
function updateAdBlockStatus (status) {

    return {
        type: ActionTypes.SET_ADBLOCK_STATUS,
        adBlockStatus: status
    };
}

/**
 * Attempt Session Refresh action.
 *
 * @param {boolean} toLoginOnFailure - Whether to go to failure or not.
 * @param {boolean} preventSecondRefresh - Whether to prevent second refresh.
 * @param {boolean} forceRefresh - Whether to refresh even second refresh prevented.
 * @returns {Promise} Response to the request.
 */
function attemptSessionRefresh (toLoginOnFailure, preventSecondRefresh, forceRefresh) {

    return (dispatch, getState) => {
        let dataSources = getDataSources(),
            shouldRedirect = function (redirectUrl) {

                return (redirectUrl && hashHistory.getCurrentLocation().pathname !== redirectUrl);
            };

        // if (_.get(
        //         getState(),
        //         ['session', 'sessionStatus']
        //     ) === SessionStatuses.CAN_NOT_REFRESH && !forceRefresh) {
        //     const isRegistration = hashHistory.getCurrentLocation().pathname.startsWith('/register');

        //     if (!isRegistration) {
        //         hashHistory.replace('/');
        //     }
            
        //     return Promise.resolve();
        // }

        if (preventSecondRefresh) {
            dispatch(setSessionStatus(SessionStatuses.CAN_NOT_REFRESH));

        }

        // remove old session not to send requests with expired session in time until we get new one
        dispatch(updateSession(null));

        return dataSources.authenticateWithRefreshToken()
            .then(() => {

                let state = getState(),
                    {
                        session,
                        paymentDetails
                    } = state,
                    redirectUrl = session.redirectUrl || '';

                dispatch(setRedirectUrl(''));

                // if (!paymentDetails.type
                //     || !paymentDetails.endDate) {

                //     hashHistory.replace('/');
                //     return;
                // }

                dispatch(fetchLinearChannels());

                // if (shouldRedirect(redirectUrl)) {
                //     console.log('asdasd')
                //     hashHistory.push(redirectUrl);
                // }
            })
            .catch((e) => {
                dispatch(attemptAnonymousLogin()).then(() => {
                        Promise.resolve();
                    }
                );

                if (toLoginOnFailure) {
                    hashHistory.replace('/login');
					console.trace("hashHistory.push", "login");
                }
            });
    };
}

// Exposed elements of the actions file.
export {
    ActionTypes,
    LoggedInStatuses,
    setLoggedInStatus,
    setRedirectUrl,
    attemptSessionRefresh,
    updateSession,
    setSessionStatus,
    SessionStatuses,
    AdBlockStatuses,
    updateAdBlockStatus,
    attemptAnonymousLogin
};


// WEBPACK FOOTER //
// ./src/js/store/actions/session.js